var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_163_1",
    "data-name": "Component 163 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1787",
    "data-name": "Rectangle 1787",
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#00feff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8571",
    "data-name": "Path 8571",
    d: "M-3.7-2.28v-.444a1.991,1.991,0,0,1,.114-.708,1.639,1.639,0,0,1,.414-.588,5.19,5.19,0,0,1,.84-.624A3.017,3.017,0,0,0-1.566-5.3a1.25,1.25,0,0,0,.27-.8,1.073,1.073,0,0,0-.42-.9A1.718,1.718,0,0,0-2.8-7.32a1.711,1.711,0,0,0-.876.2,1.387,1.387,0,0,0-.51.5,1.951,1.951,0,0,0-.234.612L-5.4-6.288a2.157,2.157,0,0,1,.486-1,2.414,2.414,0,0,1,.924-.648A3.255,3.255,0,0,1-2.748-8.16a3.476,3.476,0,0,1,1.2.21,2.19,2.19,0,0,1,.942.642A1.667,1.667,0,0,1-.24-6.192a2.076,2.076,0,0,1-.2.93,2.639,2.639,0,0,1-.54.738,4.647,4.647,0,0,1-.756.588,4.612,4.612,0,0,0-.588.42.9.9,0,0,0-.27.372,1.407,1.407,0,0,0-.066.456v.408ZM-3.18.144a.752.752,0,0,1-.552-.228A.752.752,0,0,1-3.96-.636a.752.752,0,0,1,.228-.552.752.752,0,0,1,.552-.228.752.752,0,0,1,.552.228A.752.752,0,0,1-2.4-.636a.752.752,0,0,1-.228.552A.752.752,0,0,1-3.18.144Z",
    transform: "translate(13.4 14.16)",
    fill: "#16161a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.a985b6f2244de0c0b68259bba52e7d07.svg";
export { ForwardRef as ReactComponent };